import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { AboutUsContent } from "@/components/pages/aboutUs/AboutUs";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";
import { queryAboutUs } from "@/strapiQuery/aboutUs";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );

  const aboutUsPageContentPromise = getStrapiEntity<AboutUsContent>(
    "nous-connaitre",
    queryAboutUs
  );

  const [layout, aboutUsPageContent] = await Promise.all([
    layoutPromise,
    aboutUsPageContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      reviewsConst,
      intlMessages,
      ...aboutUsPageContent,
      defaultCanonicalRoute: routes.aboutUs,
    },
    revalidate: 10,
  };
};

export { AboutUs as default } from "@/components/pages/aboutUs/AboutUs";
